import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import * as Models from '../../../models/models-index';
import { HelpTextService } from '../../../services/help/helpText.service';

@Component({
  selector: 'kpi-metric-detailed',
  templateUrl: './kpi-metric-detailed.component.html',
  styleUrls: ['../panel-elements.scss','./kpi-metric-detailed.scss'],
})
export class KpiMetricDetailedComponent implements Models.ElementComponent, OnInit {
  @Input() dataSet: Models.DataSet;
  @Input() settings: Models.ElementSettings;

  metricValue;
  metricValuePreviousPeriod;
  metricValuePreviousYear;
  metricValuePOP;
  metricValueYOY;
  metricLabel;
  title;
  titleIconClasses;
  subtitleOne;
  subtitleTwo;
  subtitleTwoLabel: string;
  metricValuePOPValue: number;
  metricValueYOYValue: number;

  constructor(
    private helpTextService: HelpTextService) {
  }

  ngOnInit() {
    const row = this.dataSet.rows[0];
    let metricIndex = this.dataSet.columns.findIndex(col => col.name === this.settings.metricName);
    let metricPreviousPeriodIndex = this.dataSet.columns.findIndex(col => col.name === this.settings.metricNamePreviousPeriod);
    let metricPreviousYearIndex = this.dataSet.columns.findIndex(col => col.name === this.settings.metricNamePreviousYear);
    let metricIndexPOP = this.dataSet.columns.findIndex(col => col.name === this.settings.metricNamePOP);
    let metricIndexYOY = this.dataSet.columns.findIndex(col => col.name === this.settings.metricNameYOY);

    this.metricValue = row[metricIndex].label ?? row[metricIndex].value;
    this.metricValuePreviousPeriod = this.dataSet.rows[0][metricPreviousPeriodIndex]?.label;
    this.metricValuePreviousYear = this.dataSet.rows[0][metricPreviousYearIndex]?.label;
    this.metricValuePOPValue = this.dataSet.rows[0][metricIndexPOP]?.value as number;
    this.metricValueYOYValue = this.dataSet.rows[0][metricIndexYOY]?.value as number;
    this.metricValuePOP = this.dataSet.rows[0][metricIndexPOP]?.label;
    this.metricValueYOY = this.dataSet.rows[0][metricIndexYOY]?.label;
    this.title = this.settings.title ?? this.dataSet.columns[metricIndex].displayName ?? this.dataSet.columns[metricIndex].name;
    this.titleIconClasses = this.settings.titleIconClasses;
    this.subtitleOne = this.metricValuePreviousPeriod;
  }

  getTrendArrowIconClass(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);

    if (isTrendUp === null || trend === 0) {
      return 'fa fa-horizontal-rule';
    } else if (trend > 0) {
      return 'fa fa-chevron-circle-up chevron-icon';
    } else if (trend < 0) {
      return 'fa fa-chevron-circle-down chevron-icon';
    }
  }

  getTrendIconColor(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);

    if (isTrendUp === null) {
      return 'bg-yellow';
    } else if (!isTrendUp) {
      return 'bg-red';
    } else if (!!isTrendUp) {
      return 'bg-green';
    }
  }

  getTrendColor(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);
    if (isTrendUp == null) {
      return 'text-yellow';
    } else if (!!isTrendUp) {
      return 'text-green';
    } else if (!isTrendUp) {
      return 'text-red';
    }
  }

  isTrendUp(value: number) {
    if (!value || value === 0)
      return null;

    return value > 0
      ? this.settings.metricInverted ? false : true
      : this.settings.metricInverted ? true : false;
  }

  openHelpTextClicked(): void {
    this.helpTextService.openHelp(this.settings.helpTextKey, this.settings.helpTextTitle);
  }

}
